import React from 'react';
import { SettingsItem } from 'design-system/SettingsItem';
import { IconDoubleRotateBold } from 'design-system/icons';
import IconBlock from 'design-system/icons/IconBlock';
import { rem, Spacer } from 'design-system';
import IconEyeSlash from 'design-system/icons/IconEyeSlash';
import IconEye from 'design-system/icons/IconEye';
import Modal from 'utils/packages/Modal';
import { isWeb } from '../../../../constants';
const ManageAccountModalContent = ({ isConnectionClosed, isAccountClosed, isHidden, toggleClosed, toggleHidden, }) => (<>
    <Spacer.H8 />
    {isHidden ? (<SettingsItem title="Unhide account" description="Its historical balance and transactions will be visible in the app again" onPress={() => ManageAccountModal.hide(toggleHidden)} icon={<IconEye colorKey="statusPositive"/>}/>) : (<SettingsItem title="Hide account" description={isAccountClosed
            ? 'Its historical balance and transactions will be hidden in the app'
            : 'This account will continue to sync, but its balance and transactions will be hidden in the app'} onPress={() => ManageAccountModal.hide(toggleHidden)} icon={<IconEyeSlash colorKey="statusOffline"/>}/>)}
    {!isConnectionClosed &&
        (isAccountClosed ? (<SettingsItem title="Mark as open" description={isHidden
                ? 'The account will start syncing again, but its balances and transactions stay invisible unless you unhide it'
                : 'The account will start syncing again'} onPress={() => ManageAccountModal.hide(toggleClosed)} icon={<IconDoubleRotateBold colorKey="statusPositive"/>}/>) : (<SettingsItem title="Mark as closed" description="This account will stop syncing, but your historical data will remain in the app" onPress={() => ManageAccountModal.hide(toggleClosed)} icon={<IconBlock colorKey="statusNegative"/>}/>))}
  </>);
const ManageAccountModal = {
    show: (props) => {
        Modal.show(<ManageAccountModalContent {...props}/>, {
            title: 'Manage account',
            containerStyle: { paddingHorizontal: isWeb ? rem(8) : 0 },
        });
    },
    hide: Modal.hide,
};
export default ManageAccountModal;
